module.exports = __webpack_public_path__ + "static/media/unterweisungen_active.56bb9a1b.jpg";